<div class="card gap-12">
  <div class="is-flex has-spacing-bottom-s">
    <app-text class="is-family-semiBold text-18 text-grey-90"> {{titleText}}</app-text>
  </div>

  <div class="is-flex has-spacing-bottom-s text-22 is-family-bold text-grey-80">
    <app-text>{{contentText}}</app-text>
    <app-text unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>

    
    <ng-container *ngIf="hasLabel">
      
      <ng-container *ngIf="positive; else negative">
        <span class="label positive is-flex text-12 is-family-semiBold" >
          <app-text> {{labelText}}</app-text>
          <app-text unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>
        </span>
      </ng-container>
      <ng-template #negative>
        <span class="label negative is-flex text-12 is-family-semiBold" >
          <app-text> {{ labelText}}</app-text>
          <app-text unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>

        </span>
      </ng-template>
    </ng-container>
  </div>
  <app-text class="text-12 text-grey-80">{{hasLabel ? explanationText: noLabelText }}</app-text>
</div>